import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reset: {
		id: 'portfolio-3.dependency-settings.footer.reset-button.reset',
		defaultMessage: 'Reset',
		description:
			'Text for the reset button which when pressed clears the changes on the dependency settings page',
	},
});
